import { useAuthStore } from 'features/auth/stores/authStore';

import { apiClient } from '../client/apiClient';
import { ENDPOINTS } from '../config/endpoints';
import type { ApiResponse } from '../types/common.types';
import type {
  InviteMemberDto,
  SetBillableRateDto,
  TeamMember,
  UpdateMemberRoleDto,
} from '../types/team.types';

const getWorkspaceId = (): string => {
  const workspaceId = useAuthStore.getState().user?.workspaceId;
  if (!workspaceId) throw new Error('No active workspace');
  return workspaceId;
};

export const teamService = {
  getMembers: (params?: { search?: string; status?: string }) => {
    const wid = getWorkspaceId();
    return apiClient.get<ApiResponse<TeamMember[]>>(ENDPOINTS.TEAM.LIST(wid), { params });
  },

  inviteMember: (data: InviteMemberDto) => {
    const wid = getWorkspaceId();
    return apiClient.post<ApiResponse<{ userId: string }>>(ENDPOINTS.TEAM.INVITE(wid), data);
  },

  updateMemberRole: (userId: string, data: UpdateMemberRoleDto) => {
    const wid = getWorkspaceId();
    return apiClient.put<ApiResponse<void>>(ENDPOINTS.TEAM.UPDATE_ROLE(wid, userId), data);
  },

  deactivateMember: (userId: string) => {
    const wid = getWorkspaceId();
    return apiClient.put<ApiResponse<void>>(ENDPOINTS.TEAM.DEACTIVATE(wid, userId));
  },

  reactivateMember: (userId: string) => {
    const wid = getWorkspaceId();
    return apiClient.put<ApiResponse<void>>(ENDPOINTS.TEAM.REACTIVATE(wid, userId));
  },

  setBillableRate: (userId: string, data: SetBillableRateDto) => {
    const wid = getWorkspaceId();
    return apiClient.put<ApiResponse<void>>(ENDPOINTS.TEAM.SET_BILLABLE_RATE(wid, userId), data);
  },
};
